import { createFileRoute } from '@tanstack/react-router';

import { PrivateLessonsPage } from '~features/private-lessons/ui/private-lessons-page';

export const Route = createFileRoute('/_auth/_layout/classes/private-lessons')({
  component: PrivateLessonsPage,
});
